export const downloadPdfFromBase64 = (base64: string, filename: string) => {
  const byteArray = new Uint8Array(
    [...atob(base64)].map(char => char.charCodeAt(0))
  )
  const blob = new Blob([byteArray], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)

  const downloadLink = document.createElement('a')
  downloadLink.href = url
  downloadLink.download = filename
  downloadLink.target = '_blank'

  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
  URL.revokeObjectURL(url)
}
